import { Pipe, PipeTransform, Injector } from '@angular/core';
import { NumberService } from '../services';

export interface IIntegerPipeArgument {
  grouping?: boolean;
  thousandSeparator?: string;
  locale?: string;
}



export class OIntegerPipe implements PipeTransform {

  protected numberService: NumberService;

  constructor(protected injector: Injector) {
    this.numberService = this.injector.get(NumberService);
  }

  transform(text: string, args: IIntegerPipeArgument): string {
    let grouping = args.grouping;
    let thousandSeparator = args.thousandSeparator;
    let locale = args.locale;

    return this.numberService.getIntegerValue(text, grouping, thousandSeparator, locale);
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'oInteger'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Injector, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
